/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {},
  ERROR: {
    FETCH_ATTACHMENTS: 'Fetch attachments'
  },
  HEADER: {
    DATE: 'Date',
    SENT_BY_F: 'Sent by',
    TITLE: 'Title'
  },
  LABEL: {
    ATTACHMENTS: 'Attachments',
    DATE: 'Date',
    DETAIL: 'Detail',
    MESSAGE: 'Message',
    NO_ROWS_COMMUNICATIONS: 'No communications',
    SENT_BY_F: 'Sent by',
    TITLE: 'Title',
    UNREAD: 'Unread'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
